import logo from '../../../assets/images/learn41.png';

function scrollTo(e: React.MouseEvent<HTMLAnchorElement>, id: string) {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
}

export default function Footer() {
  return (
    <footer className="bg-[#F4EEDF] border-t border-[#E5DCC6]">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <img src={logo} alt="Learn41" className="h-8 mb-4" />
            <p className="text-gray-600 text-sm leading-relaxed">
              The AI voice interview that sounds like the real one, feels like the real one, prepares you for the real one.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-gray-900 font-semibold text-sm uppercase tracking-wider mb-4">Product</h4>
            <ul className="space-y-2.5">
              {[
                { label: "Who It's For", id: 'who-its-for' },
                { label: 'Try an Interview', id: 'try-interview' },
                { label: 'Join Community', id: 'join-community' },
                { label: 'Book a Call', id: 'book-demo' },
              ].map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={(e) => scrollTo(e, link.id)}
                    className="text-sm text-gray-600 hover:text-primary-accent-600 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-gray-900 font-semibold text-sm uppercase tracking-wider mb-4">Legal</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-primary-accent-600 transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-primary-accent-600 transition-colors">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#E5DCC6] text-center">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Voqalize Technologies Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
